import { createFileRoute } from "@tanstack/react-router";
import PageLayout from "@/components/layout/PageLayout";
import Home from "@/components/ui/Home";

export const Route = createFileRoute("/")({
	component: () => (
		<PageLayout>
			<Home />
		</PageLayout>
	),
});
